import Vue from 'vue';
import { mountVue } from 'utils/vueContainer';

// All Vue components
import HeaderComponent from 'components/HeaderComponent';
import AccordionComponent from 'components/AccordionComponent';
import HomeAnimation from 'components/HomeAnimation';

// ------------------------------------------------------------------------
// Boot App
// ------------------------------------------------------------------------
require('boot');

// ------------------------------------------------------------------------
// Enable Barba.js Page Transitions
// ------------------------------------------------------------------------
require('transitions');

// ------------------------------------------------------------------------
// Register Vue Components
// ------------------------------------------------------------------------
Vue.component('header-component', HeaderComponent);
Vue.component('accordion-component', AccordionComponent);
Vue.component('home-animation', HomeAnimation);

// ------------------------------------------------------------------------
// Styleguide image gallery
// ------------------------------------------------------------------------
require('components/gallery');

// ------------------------------------------------------------------------
// Mount Vue Instances (outside of Barba container)
// ------------------------------------------------------------------------
mountVue('.js-vueContainer', document);

// ------------------------------------------------------------------------
// Triggers once the app has been launched
// ------------------------------------------------------------------------
document.addEventListener('AppReady', () => {
    document.documentElement.classList.remove('no-fouc');
});

// ------------------------------------------------------------------------
// Launch the app
// ------------------------------------------------------------------------
if (document.readyState === 'complete') {
    document.dispatchEvent(new CustomEvent('AppReady'));
} else {
    document.addEventListener('DOMContentLoaded', () => {
        document.dispatchEvent(new CustomEvent('AppReady'));
    });
}






// WEBPACK FOOTER //
// ./resources/assets/js/app.js